<div class="fake-radio" [class.active]="model">
    <span></span>
</div>
